import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

import axios from 'axios';
window.axios = require('axios');
axios.defaults.withCredentials=true;

import { createPinia } from 'pinia'
const pinia = createPinia()

import PerfectScrollbar from 'vue3-perfect-scrollbar'
// import "vue-awesome-paginate/dist/style.css";
import Popper from "vue3-popper"
import Notifications from '@kyvg/vue3-notification'
import tooltip from "./assets/v-tooltip/tooltip.js";
import "./assets/v-tooltip/tooltip.css";
import QuillEditor from './components/common/QuillEditor.vue';

import VueTelInput from 'vue-tel-input'
const globalOptionsVueTelInput = { mode: 'auto',};
import 'vue-tel-input/dist/vue-tel-input.css'

import ModalHiddenStep from "@/components/modals/ModalHiddenStep.vue"; 
import authMixin from './mixins/authMixin';

const baseBackendUrl = process.env.VUE_APP_BASE_URL

// Function to check app version
async function checkAppVersion() {
  try {
    // Fetch the version from the backend API with no-cache and no-store
    const response = await fetch(baseBackendUrl + '/api/version', { 
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    const currentVersion = localStorage.getItem('app_version');
    
    // Force reload if version mismatch
    if (currentVersion !== data.version) {
      console.log('New version detected, refreshing...');
      localStorage.setItem('app_version', data.version);
      
      // Clear application cache
      if ('caches' in window) {
        try {
          const cacheNames = await caches.keys();
          await Promise.all(
            cacheNames.map(cacheName => caches.delete(cacheName))
          );
        } catch (err) {
          console.error('Error clearing caches:', err);
        }
      }
      
      // Force reload without cache
      window.location.reload(true);
    } else {
      localStorage.setItem('app_version', data.version);
    }
  } catch (error) {
    console.error('Error fetching app version:', error);
  }
}

// Check version on initial load
checkAppVersion();

// Check version periodically (every 5 minutes)
setInterval(checkAppVersion, 5 * 60 * 1000);

const app = createApp(App)
    .use(pinia)
    .use(router)
    .use(i18n)
    .use(PerfectScrollbar)
    .use(Notifications)
    .use(VueTelInput, globalOptionsVueTelInput)
    .directive("tooltip", tooltip)
    .mixin(authMixin)
    .component("ModalHiddenStep", ModalHiddenStep)
    .component("Popper", Popper)
    .component('QuillEditor', QuillEditor);

    
app.mount('#app')


